export default "__VITE_PUBLIC_ASSET__71485456__"